import Column from 'layout/Components/Column'
import { RowCenter } from 'layout/Components/Row'
import { Trans } from 'react-i18next'
import { useFiatCurrencies } from 'state/app/hooks'
import styled from 'styled-components'
import { Icons } from 'svgs'
import Image from 'UIKit/Image'
import Text from 'UIKit/Text'
import PaymentCommitmentsBar from 'views/Payment/components/PaymentCommitments/PaymentCommitmentsBar'
import { DepositOptionEnums } from '../../Menu'
import { ICommitmentsControl } from '../types'
import { CountListCurrencyDeposit, PaymentHeading } from './styles'

export const DepositOptionContent: React.FC<{
  onSelect: (tab: DepositOptionEnums) => void
  commitmentsControl?: ICommitmentsControl
}> = ({ onSelect, commitmentsControl }) => {
  const fiatCurrencies = useFiatCurrencies()

  return (
    <Column gap="var(--pm-space-component, 20px)">
      {commitmentsControl && <PaymentCommitmentsBar commitmentsControl={commitmentsControl} />}

      <Column gap="var(--pm-space-label, 8px)">
        <PaymentHeading>
          <Trans>I don’t have Crypto assets</Trans>:
        </PaymentHeading>

        <StyledCard onClick={() => onSelect(DepositOptionEnums.Fiat)}>
          <Icons.CashSolidIcon />
          <Column flex={1} gap="4px" py="12px">
            <Text small bold color="white">
              <Trans>Deposit Fiat</Trans>
            </Text>
            <Text
              color="var(--pm-text-note-color)"
              fontWeight={400}
              fontSize="var(--pm-text-note-size)"
              letterSpacing={'-0.28px'}
            >
              <Trans>Bank Transfer</Trans> • <Trans>{{ value: 2 }} mins</Trans>
            </Text>
          </Column>
          <RowCenter>
            {fiatCurrencies.map((currency, index) => (
              <Image
                mr={index < fiatCurrencies.length - 1 ? '-6px' : 0}
                style={{
                  zIndex: index,
                }}
                key={`fiat-source-${currency.code}`}
                src={currency.logo}
                width={20}
                height={20}
                alt={`fiat-${currency.code}`}
              />
            ))}
          </RowCenter>
        </StyledCard>
        <StyledCard onClick={() => onSelect(DepositOptionEnums.BuyCrypto)}>
          <Icons.CardATMIcon />
          <Column flex={1} gap="4px" py="12px">
            <Text small bold color="white">
              <Trans>Use Card</Trans>
            </Text>
            <Text
              whiteSpace="nowrap"
              color="var(--pm-text-note-color)"
              fontWeight={400}
              fontSize="var(--pm-text-note-size)"
              letterSpacing={'-0.28px'}
            >
              <Trans>{{ value: '$10,000' }} limit</Trans> • <Trans>{{ value: 5 }} mins</Trans>
            </Text>
          </Column>
          <RowCenter gap="4px">
            <Image
              src={'/images/payment/mastercard.png'}
              width={24}
              height={24}
              alt={'fiat-srcCard'}
              style={{ minWidth: '20px' }}
            />
            <Image
              src={'/images/payment/visa.png'}
              width={32}
              height={32}
              alt={'fiat-srcCard'}
              style={{ minWidth: '32px' }}
            />
            <Image
              src={'/images/payment/apple-pay.png'}
              width={32}
              height={32}
              alt={'fiat-srcCard'}
              style={{ minWidth: '32px' }}
            />
            <Image
              src={'/images/payment/google-pay.png'}
              width={32}
              height={32}
              alt={'fiat-srcCard'}
              style={{ minWidth: '32px' }}
            />
          </RowCenter>
        </StyledCard>
      </Column>
      <Column gap="var(--pm-space-label, 8px)">
        <PaymentHeading>
          <Trans>I have Crypto assets</Trans>:
        </PaymentHeading>

        <StyledCard onClick={() => onSelect(DepositOptionEnums.Crypto)}>
          <Icons.LightningIcon />
          <Column flex={1} gap="4px" py="12px">
            <Text small bold color="white">
              <Trans>Deposit Crypto</Trans>
            </Text>
            <Text
              color="var(--pm-text-note-color)"
              fontWeight={400}
              fontSize="var(--pm-text-note-size)"
              letterSpacing={'-0.28px'}
            >
              ∞ <Trans>No Limit</Trans> • <Trans>Instant</Trans>
            </Text>
          </Column>
          <CountListCurrencyDeposit />
        </StyledCard>
      </Column>
    </Column>
  )
}

const StyledCard = styled(RowCenter)`
  padding-inline: 12px;
  cursor: pointer;
  gap: 16px;

  border-width: 1px;
  border-style: solid;
  border-color: var(--pm-border);
  border-radius: var(--pm-trigger-radius);

  ${({ theme }) => theme.mediaQueries.md} {
    transition: 0.2s all;

    &:hover {
      background: var(--pm-border-active);
      background: var(--pm-card-active);
    }
  }
`
